import type { StyleSpecification } from "maplibre-gl";
import dark from "./dark.json";

export const mapStyles = {
  dark: dark as StyleSpecification,
};

export type MapStyleId = keyof typeof mapStyles;
